export enum Appearance {
  GREEN = 'green',
  INVISIBLE = 'invisible',
  PINK = 'pink',
  PRIMARY = 'primary',
  RED = 'red',
  SECONDARY = 'secondary',
  SP3 = 'sp3',
}
